
import { Enums } from '../common/enums'

import { ICopyable, IOpData } from '../util/interfaces'

import { OpConsumerType } from './op-consumer-type'
import { OpDataType } from './op-data-type'


export class OpConsumerTypeData implements IOpData, ICopyable<OpConsumerTypeData> {

    // Properties

    public idConsumerTypeData: number
    public idConsumerType: number
    public idDataType: number
    public indexNbr: number
    public value: any

    // Properties end


    // NavigationProperties

    public consumerType: OpConsumerType
    public dataType: OpDataType

    // NavigationProperties end


    constructor(opObj: any = null) {
        if (opObj instanceof OpConsumerTypeData) {
            this.copy(<OpConsumerTypeData>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }


    // IOpChangeState implementation

    public opState: Enums.OpChangeState

    // IOpChangeState implementation end


    // IOpData implementation

    public get idData() { return this.idConsumerTypeData }
    public set idData(idData: number) { this.idConsumerTypeData = idData }

    public get indexNBR() { return this.indexNbr }
    public set indexNBR(indexNBR: number) { this.indexNbr = indexNBR }

    // IOpData implementation end

    public toString() {
        return "ConsumerTypeData [" + this.idData + "]"
    }

    public fromJSON(opObj: any, compress: boolean = false) {
        if (opObj) {
            this.idConsumerTypeData = opObj.ID_CONSUMER_DATA
            this.idConsumerType = opObj.ID_CONSUMER
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE
            this.opState = opObj.OpState

            this.dataType = opObj._DataType != null ? new OpDataType(opObj._DataType) : null
            this.consumerType = opObj._ConsumerType != null ? new OpConsumerType(opObj._ConsumerType) : null
        } else {
            this.idConsumerTypeData = 0;
            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compress: boolean = false): any {
        return {
            ID_CONSUMER_DATA: this.idConsumerTypeData,
            ID_CONSUMER: this.idConsumerType,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value
        }
    }

    public static fromIOpData(data: IOpData): OpConsumerTypeData {
        const newData: OpConsumerTypeData = new OpConsumerTypeData(null)

        newData.idConsumerTypeData = data.idData
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }


    // #region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpConsumerTypeData {
        const consumerTypeData: OpConsumerTypeData = new OpConsumerTypeData(null)

        consumerTypeData.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return consumerTypeData
    }

    public copy(source: OpConsumerTypeData, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {

        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            this.consumerType = source.consumerType != null ? source.consumerType.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues) : null

            this.dataType = source.dataType != null ? source.dataType.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues) : null
        }

        if (includeCustomProperties) {
            // No Custom Properties
        }

        if (includeDataList) {
            // No Data list
        }

        if (includeDynamicValues) {
             // No Dynamic Values
        }

        this.idConsumerTypeData = source.idConsumerTypeData
        this.idConsumerType = source.idConsumerType
        this.idDataType = source.idDataType
        this.indexNbr = source.indexNbr
        this.value = source.value
        
        this.opState = source.opState
    }
}